export const APP_SWITCH_STATES = {
    APP_SWITCH_LOADING: "APP_SWITCH_LOADING",
    APP_SWITCH_READY: "APP_SWITCH_READY",
}

export const APP_SWITCH_STATES_MESSAGE_MAP = {
    [APP_SWITCH_STATES.APP_SWITCH_LOADING]: "",
    [APP_SWITCH_STATES.APP_SWITCH_READY]: "",
}

export const APP_SWITCH_TOKEN = 'switch_exchange_token';

export const APP_SWITCH_RESPONSE_ACTIONS = {
    SUCCESSFULLOGIN: 'SUCCESSFULLOGIN',
    ALREADYLOGGEDINSAMEUSER: 'ALREADYLOGGEDINSAMEUSER',
    ALREADYLOGGEDINDIFFERENTUSER: 'ALREADYLOGGEDINDIFFERENTUSER',
    LOGIN: 'LOGIN'
}